import { useEffect } from 'react'

import { Page } from '@loadsmart/miranda-react'

import AppLayout from 'core/ui/components/AppLayout'
import Header from 'core/ui/components/Header'

import IntegrationComponent from './components/integration/Integration'
import { useIntegrations } from './hooks/useIntegrations'

export default function IntegrationsPage() {
  const { getIntegration, isLoadingIntegrations, integrations } = useIntegrations()

  useEffect(() => {
    getIntegration()
  }, [getIntegration])

  return (
    <AppLayout>
      <Header />
      <Page.Content>
        <Page.Body>
          <IntegrationComponent
            integrations={integrations}
            isLoadingIntegrations={isLoadingIntegrations}
          />
        </Page.Body>
      </Page.Content>
    </AppLayout>
  )
}
